// pluginLoader.js
let loadPromise = null;

export const loadPluginScript = () => {
  // If it's already loading or loaded, return the same promise
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    // If it already loaded somehow, resolve immediately
    if (typeof window.loadCommonPluginScreen === 'function') {
      return resolve();
    }

    const statsScript = document.createElement("script");
    statsScript.src = `https://duhkahawczku4.cloudfront.net/uhf/${process.env.REACT_APP_BUILD}/current/plugin.iife.js`;
    statsScript.async = true;

    statsScript.onload = () => {
    // Give the script 20ms to completely finish any internal microtasks/promises
        setTimeout(() => {
            if (typeof window.loadCommonPluginScreen === 'function') {
            resolve();
            } else {
            reject(new Error("Script loaded, but loadCommonPluginScreen is missing."));
            }
        }, 20); 
    };

    statsScript.onerror = (err) => {
      reject(new Error("Failed to download the plugin script."));
    };

    document.body.appendChild(statsScript);
  });

  return loadPromise;
};